import type { SearchSchemaInput } from '@tanstack/react-router';
import { parseEnum } from '@/shared/lib/listSearch';
import type { ContractType } from '@/api/generated/model';
import { CONTRACT_TYPES } from './contractMeta';

/**
 * What another screen can hand `/contracts/new`: a player's Contract tab
 * preselects the player, the Actions tab also picks the type.
 */
export interface ContractNewSearch {
  playerId?: string | undefined;
  type?: ContractType | undefined;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function validateContractNewSearch(
  search: Partial<Record<keyof ContractNewSearch, unknown>> & SearchSchemaInput,
): ContractNewSearch {
  return {
    playerId:
      typeof search.playerId === 'string' && UUID.test(search.playerId)
        ? search.playerId
        : undefined,
    type: parseEnum(search.type, CONTRACT_TYPES),
  };
}
